import React from 'react';
import useStores from '@stores/useStores';
import { debounce } from 'lodash';
import { apiAuthCaller } from '@services/apiCaller';
import TextInputField from '@ui-library/textInput/textInput';
import exportResponseError from '@utils/exportResponseError';
import { SmartRetry } from '@utils/retry';
import axios from 'axios';
import Loading from '@ui-library/Loading';
import { FixMe } from '@utils/types';
import { ConfigEditorProps } from '.';

export interface S3Config {
  bucketName?: string;
  prefix?: string;
}
interface S3ConfigurationProps extends ConfigEditorProps<S3Config> {
  config: Partial<S3Config>;
  role: string;
}
const retry = new SmartRetry<FixMe>({ times: 1 });

const S3: React.FC<S3ConfigurationProps> = ({
  defaultValue,
  onChangeConfig,
  accountId,
  onChangeColumns,
  config,
  role,
  onChangeLoadingState,
  columnsAsObject,
  isViewOrUpdate,
  mappedToDestination,
}: S3ConfigurationProps) => {
  const [loadingCols, setLoadingColumns] = React.useState(false);
  React.useEffect(() => {
    if (onChangeLoadingState) {
      onChangeLoadingState(loadingCols);
    }
  }, [loadingCols]);
  const onChange = React.useCallback(
    debounce((newConfig: FixMe) => {
      if (isViewOrUpdate && mappedToDestination) {
        return;
      }
      onChangeConfig(newConfig);
      const conf = { ...config, ...newConfig };
      if (conf.bucketName) {
        setLoadingColumns(true);
        retry
          .exec(() =>
            apiAuthCaller(userStore.token, false, 35000).post(
              `cloudSources/sources/info/${role}/columns`,
              {
                accountId,
                ...conf,
              },
              {
                cancelToken: new axios.CancelToken((c) => {
                  retry.setCancelMethod(c);
                }),
              },
            ),
          )
          .then((resp) => {
            const columns = columnsAsObject
              ? resp.data?.columns
              : resp?.data?.columns?.map((col: { name: string }) => col.name);
            if (!columns?.length) {
              throw {
                message: 'No columns found',
              };
            }
            onChangeColumns(columns);
            setLoadingColumns(false);
          })
          .catch((err) => {
            if (err.constructor.name === 'Cancel') {
              return;
            }
            onChangeColumns([]);
            messagesStore.showErrorMessage(exportResponseError(err)?.message);
            setLoadingColumns(false);
          });
      } else {
        onChangeColumns([]);
      }
    }, 1000),
    [config],
  );
  const { userStore, messagesStore } = useStores();
  return (
    <div className="s3_container">
      <TextInputField
        suffix={(loadingCols && <Loading />) || ' '}
        field={{
          default: defaultValue?.bucketName,
          value: 'bucketName',
          label: 'S3 Bucket Name',
        }}
        width={475}
        onChange={(_, value) => {
          onChange({ bucketName: value });
        }}
        type="input"
        disabled={isViewOrUpdate}
      />
      <div style={{ marginTop: 24 }} />
      <TextInputField
        suffix={' '}
        field={{
          label: 'Prefix',
          default: defaultValue?.prefix,
          value: 'prefix',
        }}
        width={475}
        onChange={(_, value) => {
          onChange({ prefix: value });
        }}
        type="input"
        disabled={isViewOrUpdate}
      />
      <div style={{ marginTop: 24 }} />
    </div>
  );
};

export default S3;
